import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { AppsOutlined } from "@material-ui/icons";

function DialogPindahAplikasi(props) {
  const { apps, open, handleClose } = props;

  const handleListItemClick = (app) => {
    window.location.href = app.url;
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Silahkan Pilih Aplikasi</DialogTitle>
      <div
        style={{
          marginTop: "-1rem",
        }}>
        <List>
          {apps.map((app, i) => (
            <ListItem button onClick={() => handleListItemClick(app)} key={i}>
              <ListItemAvatar>
                <Avatar>
                  <AppsOutlined />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={app.nama_aplikasi} />
            </ListItem>
          ))}
        </List>
      </div>
    </Dialog>
  );
}

DialogPindahAplikasi.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function ModalPilihAplikasi({ apps, open, handleClose }) {
  return (
    <DialogPindahAplikasi apps={apps} open={open} handleClose={handleClose} />
  );
}
